import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutePipe, RuntimePipe, VideoPipe, VideoTypePipe, ObjectValuesPipe, MetaPipe, KebabCasePipe, UrlPipe, VideoSourcesPipe, SanitizePipe, SanitizeIframe, TypeformPipe, AsyncTimerPipe, HasVideoPipe, SafeUrlPipe, SafeHtmlPipe, ContentBuilderObject } from "../";
import { FilterByTypePipe, FilterOutTypePipe, RemoveEmptyRowsPipe } from "../filter.pipe";



@NgModule({
    declarations: [
        RoutePipe, RuntimePipe, VideoPipe, VideoTypePipe, ObjectValuesPipe, MetaPipe, KebabCasePipe, UrlPipe, VideoSourcesPipe, SanitizePipe, SanitizeIframe, TypeformPipe, AsyncTimerPipe, FilterByTypePipe, FilterOutTypePipe, RemoveEmptyRowsPipe, HasVideoPipe, SafeUrlPipe, SafeHtmlPipe, ContentBuilderObject
    ],
    imports: [CommonModule],
    exports: [
        RoutePipe, RuntimePipe, VideoPipe, VideoTypePipe, ObjectValuesPipe, MetaPipe, KebabCasePipe, UrlPipe, VideoSourcesPipe, SanitizePipe, SanitizeIframe, TypeformPipe, AsyncTimerPipe, FilterByTypePipe, FilterOutTypePipe, RemoveEmptyRowsPipe, HasVideoPipe, SafeUrlPipe, SafeHtmlPipe, ContentBuilderObject
    ]
})

export class SharedPipesModule {
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/module/shared.pipes.module.ts